export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "http://localhost:3005";
export const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE || "sandbox";
export const cometChatAppId =
  process.env.REACT_APP_COMETCHAT_APP_ID || "167578873d686cd88";
export const cometChatRegion =
  process.env.REACT_APP_COMETCHAT_REGION || "in";
export const cometChatAuthKey =
  process.env.REACT_APP_COMETCHAT_AUTH_KEY ||
  "8f666384e0b8a72df788dad4da444e9b52ce97e5";

export const olaMapsApiKey =
  process.env.REACT_APP_OLA_MAPS_API_KEY || "vElgl6QLTdvIm6CZy5sazLRyj2STohTN1Nd7ilDU";
